import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import Section from '../../section';
import Container from '../../container';
import ContentBlock from '../../content-block';
import RenderMd from '../../render-md';
import ShareList from '../../share-list';
import Button from '../../button';
import TextWave from '../../text-wave';

const shareListStyles = `
  margin: 0;
  align-self: center;
`;

const DetailOverview = ({
  sectionTitle,
  content,
  slug,
  isLight,
  projectTitle,
  buttonLink,
}) => {
  const url = `https://wavesforwater.org/fundraisers/${slug}`;
  const twitterShare = `Support ${projectTitle} with @wavesforwater ${url}`;

  return (
    <OverviewSection isLight={isLight}>
      <Container>

        <ContentBlock>
          <TextWave>
            <h2>{sectionTitle}</h2>
          </TextWave>

          <RenderMd source={content} />

          <LinkWrap>
            {buttonLink &&
              <Button href={buttonLink}>Contact Organizer</Button>
            }

            <ShareList
              styles={shareListStyles}
              twitterShareMessage={twitterShare}
              fbShareMessage={url}
              hasCircle
            />
          </LinkWrap>

        </ContentBlock>

      </Container>
    </OverviewSection>
  );
};

const OverviewSection = styled(Section)`
  background: ${props => props.isLight ? '#fff' : props.theme.lightGray};

  h2 {
    ${screen.below(bp.portrait, `
      max-width: 440px;
    `)}
  }
`;

const LinkWrap = styled.div`
  display: grid;
  margin-top: 60px;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 40px;

  ${screen.below(bp.mobile, `
    margin-top: 30px;
    grid-template-columns: 1fr;
  `)};
`;

DetailOverview.propTypes = {
  sectionTitle: PropTypes.string,
  projectTitle: PropTypes.string,
  content: PropTypes.string,
  slug: PropTypes.string,
  isLight: PropTypes.bool,
  buttonLink: PropTypes.string,
};

export default DetailOverview;
